import { css } from "styled-components";
import token from "styled-token";
var checkmark = encodeURIComponent("\n    <svg width=\"10\" height=\"10\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path d=\"M9.79.22a.72.72 0 0 0-1.04 0L3.72 6.15l-2.47-2.6a.72.72 0 0 0-1.04 0c-.28.29-.28.8 0 1.09l3 3.15c.15.17.31.21.51.21s.36-.08.52-.21L9.8 1.31c.28-.29.28-.8 0-1.09z\" fill=\"#FFF\" fill-rule=\"nonzero\"/>\n    </svg>\n");
var dash = encodeURIComponent("\n    <svg width=\"12\" height=\"2\" viewBox=\"0 0 12 2\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path d=\"M11 2H1C0.447715 2 0 1.55228 0 1C0 0.447715 0.447715 0 1 0H11C11.5523 0 12 0.447715 12 1C12 1.55228 11.5523 2 11 2Z\" fill=\"#FFF\" fill-rule=\"evenodd\"/>\n    </svg>\n");

var defaultCSS = function defaultCSS(props) {
  return token({
    borderRadius: "radii.md"
  }, function (tokens) {
    return css(["border-radius:", "px;"], tokens.borderRadius);
  })(props);
};

var checkedCSS = function checkedCSS(props) {
  return token({
    background: "Input.borderColorInteractive",
    borderWidth: "Radio.borderWidth"
  }, function (tokens) {
    return css(["border-width:", "px;background:url(\"data:image/svg+xml;utf8,", "\") 2px 3px no-repeat,", ";background-size:12px;"], tokens.borderWidth, checkmark, tokens.background);
  })(props);
};

var indeterminateCSS = function indeterminateCSS(props) {
  return token({
    background: "Input.borderColorInteractive",
    borderWidth: "Radio.borderWidth"
  }, function (tokens) {
    return css(["border-color:", ";border-width:", "px;background:url(\"data:image/svg+xml;utf8,", "\") 2px 7px no-repeat,", ";background-size:12px;"], tokens.background, tokens.borderWidth, dash, tokens.background);
  })(props);
};
/** @mixin checkboxStateMixin */

/** @method */


export var checkboxStateMixin = function checkboxStateMixin(state) {
  return function (props) {
    switch (state) {
      case "checked":
        return checkedCSS(props);

      case "indeterminate":
        return indeterminateCSS(props);

      default:
        return defaultCSS(props);
    }
  };
};